import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mic, CheckSquare, Layers, FileText, Filter, Settings, MessageSquare, BookOpen, Database, Rss, Inbox, Zap, Clock, Wrench, Bot, Globe, FilePen, Workflow, Package, Activity, Terminal, Plug } from 'lucide-react';
interface SideDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  activeView: string;
  onNavigate: (view: string) => void;
  isMobile: boolean;
}
const navSections = [{
  items: [{
    id: 'voice',
    label: 'Voice',
    icon: Mic
  }, {
    id: 'chat',
    label: 'Chat',
    icon: MessageSquare
  }, {
    id: 'code',
    label: 'Code',
    icon: Terminal
  }, {
    id: 'tasks',
    label: 'Tasks',
    icon: CheckSquare
  }, {
    id: 'actions',
    label: 'Actions',
    icon: Zap
  }, {
    id: 'artifacts',
    label: 'Artifacts',
    icon: Package
  }, {
    id: 'transcripts',
    label: 'Transcripts',
    icon: Clock
  }]
}, {
  items: [{
    id: 'lists',
    label: 'Lists',
    icon: Layers
  }, {
    id: 'summaries',
    label: 'Summaries',
    icon: FileText
  }, {
    id: 'documents',
    label: 'Documents',
    icon: FilePen
  }, {
    id: 'library',
    label: 'Library',
    icon: BookOpen
  }, {
    id: 'data',
    label: 'Data',
    icon: Database
  }, {
    id: 'messages',
    label: 'Messages',
    icon: Inbox
  }, {
    id: 'feed',
    label: 'Feed',
    icon: Rss
  }, {
    id: 'browser',
    label: 'Browser',
    icon: Globe
  }]
}, {
  items: [{
    id: 'agents',
    label: 'Agents',
    icon: Bot
  }]
}, {
  items: [{
    id: 'workflows',
    label: 'Workflows',
    icon: Workflow
  }, {
    id: 'integrations',
    label: 'Integrations',
    icon: Plug
  }, {
    id: 'source-rules',
    label: 'Source Rules',
    icon: Filter
  }, {
    id: 'skills',
    label: 'Skills',
    icon: Wrench
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }]
}, {
  items: [{
    id: 'sync-history',
    label: 'Sync History',
    icon: Activity
  }]
}];
export function SideDrawer({
  isOpen,
  onClose,
  activeView,
  onNavigate,
  isMobile
}: SideDrawerProps) {
  return <AnimatePresence data-id="element-1706">
      {isOpen && <>
          {isMobile && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/50 z-30" onClick={onClose} data-id="element-1707" />}
          <motion.aside initial={{
        x: -280
      }} animate={{
        x: 0
      }} exit={{
        x: -280
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="fixed left-0 top-0 bottom-0 w-[280px] bg-[#1a1a20] z-40 flex flex-col" data-id="element-1708">
            <div className="flex items-center justify-end pt-4 px-4 pb-4" data-id="element-1709"><button onClick={onClose} className="w-8 h-8 flex items-center justify-center hover:bg-white/5 rounded-lg transition-colors" aria-label="Close" data-id="element-1710"><X size={16} className="text-[#8a8680]/60" strokeWidth={1.5} data-id="element-1711" /></button></div>
            <nav className="py-2 flex-1 overflow-y-auto" data-id="element-1712">
              {navSections.map((section, sIndex) => <React.Fragment key={sIndex} data-id="element-1713">
                  {sIndex > 0 && <div className="h-px bg-[#8a8680]/10 mx-6 my-3" data-id="element-1714" />}
                  {section.items.map(item => {
              const Icon = item.icon;
              const isActive = activeView === item.id;
              return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center gap-3 px-6 py-2.5 transition-colors ${isActive ? 'text-[#e8e4df]' : 'text-[#8a8680] hover:text-[#e8e4df]/80'}`} data-id="element-1715"><Icon size={16} strokeWidth={1.5} data-id="element-1716" /><span className="text-[14px]" data-id="element-1717">{item.label}</span></button>;
            })}
                </React.Fragment>)}
            </nav>
          </motion.aside>
        </>}
    </AnimatePresence>;
}